import { DatePicker } from "antd";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDate } from "../../../services/store/slices/cart";
import dayjs from "dayjs";
import { useIntl } from "react-intl";

interface AppointmentDatePickerProps {}

const AppointmentDatePicker: FC<AppointmentDatePickerProps> = ({}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { date, start_time, location } = useSelector(
    (state: {
      cart: {
        services: {
          date: string | null;
          start_time: string | null;
        };
        location: { id: number | null };
      };
    }) => {
      return {
        date: state.cart.services.date,
        start_time: state.cart.services.start_time,
        location: state.cart.location,
      };
    }
  );
  console.log(date, start_time, location?.id);
  const onChange = (value: any, dateString: any) => {
    dispatch(setDate(dateString));
  };
  return (
    <div className="shadow p-6 space-y-4 rounded-lg min-h-[50vh]">
      <div className="space-y-4">
        <h4 className="text-salon-primary text-xl ">
          {intl.formatMessage({ id: "chooseAppointmentDay" })}
        </h4>
        <p className="text-color-sec-title">
          {intl.formatMessage({ id: "chooseAppointmentDayDescription" })}
        </p>
      </div>

      <div>
        <DatePicker
          value={date ? dayjs(date) : null}
          placement="bottomLeft"
          //   open={true}
          onChange={onChange}
          disabledDate={(date: any) => {
            const d = new Date();
            d.setDate(d.getDate() - 1);
            return date.isBefore(d);
          }}
        />
      </div>
    </div>
  );
};

export default AppointmentDatePicker;
